export default {
  addToCart: 'Add to basket',
  back: 'Back',
  cancelChanges: 'Cancel changes',
  chooseExpDate: 'Choose a date',
  date: 'Date',
  endDate: 'End date',
  experienceType: 'Type',
  experienceVibe: 'Vibe',
  filterExpDate: 'Filter by date',
  filterExperienceType: 'Filter by type',
  filterExperienceVibe: 'Filter by vibe',
  next: 'Next',
  noExperiences: 'No Experiences',
  previous: 'Previous',
  proceedToCheckout: 'Proceed to checkout',
  removeFromReservation: 'Remove from reservation',
  saveChanges: 'Save changes',
  search: 'Search',
  selectDate: 'Select date',
  startDate: 'Start date',
  submit: 'Submit',
  viewCalendar: 'Calendar',
  filterExperienceTypeScreenReader:
    'Use these filters to narrow results. Content updates automatically when a filter is selected.',
};
